export const PRIMARY_COLOR = "primary_color";
export const PRIMARY_DARK_COLOR = "primary_dark_color";
export const PRIMARY_LIGHT_COLOR = "primary_light_color";

export const DEFAULT_PRIMARY_COLOR = "#0D7DC2";
export const DEFAULT_PRIMARY_DARK_COLOR = "#105986";
export const DEFAULT_PRIMARY_LIGHT_COLOR = "#fefefe";
